import { Link } from 'react-router'
import { AspectRatio, Image, Avatar } from '@mantine/core'
import { IconChevronRight, IconStar } from '@tabler/icons-react'
import Stat from '../Stat/Stat'
import classes from './StatCard.module.css'
import { Typography } from '../../common/typography'

export default function StatCard({
  image,
  name,
  id,
  rank,
  score,
  competition_id,
  title,
  link_title,
  isPlayer = true,
}: {
  image: string
  name: string
  id: number
  rank: number | null
  score: number | string | null
  competition_id: number
  title?: string
  link_title?: string
  isPlayer?: boolean
}) {
  const profileLink = isPlayer
    ? `/competitions/${competition_id}/players/${id}`
    : `/competitions/${competition_id}/teams/${id}/overview`

  const linkTitleLink = isPlayer
    ? `/competitions/${competition_id}/players/${id}`
    : `/competitions/${competition_id}/ranks/teams`

  const ranksLink = isPlayer
    ? `/competitions/${competition_id}/ranks/players`
    : `/competitions/${competition_id}/ranks/teams`

  return (
    <div className={classes.container}>
      {(title || link_title) && (
        <div className={classes.row}>
          <Typography level={2} fw={500} lh="125">
            {title}
          </Typography>
          <Link to={linkTitleLink} className={classes.linkTitleRow}>
            <Typography
              level={3}
              fc={{ light: 'primary-5', dark: 'primary-4' }}
              fs="xs"
              className={classes.linkTitle}
            >
              {link_title}
            </Typography>
            <IconChevronRight className={classes.icon} />
          </Link>
        </div>
      )}
      <div className={classes.row}>
        <Link to={profileLink} className={classes.dataContainer}>
          <AspectRatio ratio={1 / 1}>
            {image ? (
              <Image
                src={image}
                alt={name}
                className={classes.image}
                fit="scale-down"
              />
            ) : (
              <Avatar />
            )}
          </AspectRatio>
          <Typography lh="150">{name}</Typography>
        </Link>
      </div>
      <Link to={ranksLink} className={classes.stats}>
        <Stat value={rank} isValueSub background="gray" iconColor="#C92A2A" />
        <Stat
          value={score}
          isValueSub={false}
          icon={IconStar}
          background="gray"
        />
      </Link>
    </div>
  )
}
